
module.exports = {"attributes":{"width":"16","height":"13","viewBox":"0 0 30 21"},"content":"<path d=\"M29.8.4a313 313 0 0 0-2 20.6h-12A61 61 0 0 1 23.5.4h6.4zM14.1.4c-.9 6.7-1.7 13.4-2 20.6H0C1.3 13.8 3.7 7 7.5.4h6.6z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
